import { datajsAll } from '../shared/utils';
import Swiper, { Autoplay, Navigation } from 'swiper';

export default class CarouselBlock {
	static init() {
		const carousels = datajsAll('carousel-block');

		carousels.forEach((carousel) => {
			this.carouselConfig(carousel);
		});
	}

	// Setup Carousel
	static carouselConfig(carousel) {
		let autoplay = carousel.dataset.autoplay || false;
		let delay = carousel.dataset.delay || 5000;
		let slidesPerView = carousel.dataset.slidesPerView || 1;
		let navigation = carousel.dataset.navigation || true;

		let swiperConfig = {
			modules: [Autoplay, Navigation],
			speed: 500,
			loop: true,
			autoHeight: true,
			autoplay: false, // disable autoplay initially
			slidesPerView: slidesPerView,
			breakpoints: {
				// when window width is >= 640px
				640: {
					slidesPerView: slidesPerView,
				},
				// when window width is < 640px
				0: {
					slidesPerView: 1,
				}
			},
			spaceBetween: 16,
		};

		if (navigation) {
			swiperConfig.navigation = {
				nextEl: '[data-js~=carousel-next]',
				prevEl: '[data-js~=carousel-prev]',
			};
		}

		// Create swiper instance
		const swiper = new Swiper(carousel, swiperConfig);

		// Create Intersection Observer
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (autoplay) {
						swiper.params.autoplay = {
							delay: delay,
							pauseOnMouseEnter: false,
						};
						swiper.autoplay.start();
					}
				} else {
					swiper.autoplay.stop();
				}
			});
		});

		// Start observing
		observer.observe(carousel);
	}
}